var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix",attrs:{"id":"footer"}},[_c('div',{staticClass:"footer-wrapper"},[_c('h1',[_vm._v("@2022 by Donald Lam")]),_c('h1',[_vm._v("Supported by Vue.js")])])])
}]

export { render, staticRenderFns }